export default "__VITE_ASSET__1gjGhDid__"